import { render } from "./MessageModal.vue?vue&type=template&id=2ebc1556&scoped=true"
import script from "./MessageModal.vue?vue&type=script&lang=js"
export * from "./MessageModal.vue?vue&type=script&lang=js"

import "./MessageModal.vue?vue&type=style&index=0&id=2ebc1556&lang=scss&scoped=true"

import exportComponent from "/Users/stepanmaksimov/Documents/Claude/Projects/A.sk/answerio-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebc1556"]])

export default __exports__